import api from '@/utils/api'

export default {
    getTheming() {
        return api.get(`theming/current`)
    },
    updateTheming(data) {
        return api.put(`theming/current`, data)
    }
}
